import { render } from "./NotificationSidebar.vue?vue&type=template&id=3c5996b0&ts=true"
import script from "./NotificationSidebar.ts?vue&type=script&lang=ts"
export * from "./NotificationSidebar.ts?vue&type=script&lang=ts"

import exportComponent from "D:\\bms_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__